import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { SpecificationTaskCreateState } from '../../types/specification-task-create';
import type { SpecificationTaskCreateModel } from '../specification-task-create-model';
import { SpecificationJurisdiction } from '../../enums';

@injectable()
export class SpecificationTaskCreateModelImpl extends AbstractModel<SpecificationTaskCreateState> implements SpecificationTaskCreateModel {
    protected _modelData: SpecificationTaskCreateState = {
        taskId: '',
        formData: {
            // 默认受理局, 初始化时, 根据当前语言环境设置
            jurisdiction: SpecificationJurisdiction.CN,
            inventionDisclosure: '',
            claims: '',
        },
        formErrors: {},
        loadingSubmit: false,
    };

    get modelData(): SpecificationTaskCreateState {
        return this._modelData;
    }
}
